import { CenterLogo } from './formLogo';

/** Light/dark brand mark. Apps style `.app-logo--light` / `--dark` via `data-theme`. */
export const ThemedLogo = ({
  src,
  srcDark,
  width,
  height,
  alt = '',
}: {
  src: string;
  srcDark?: string;
  width?: string;
  height?: string;
  alt?: string;
}) => {
  if (!srcDark) {
    return <CenterLogo src={src} width={width} height={height} alt={alt} />;
  }
  return (
    <>
      <CenterLogo
        className="app-logo--light"
        src={src}
        width={width}
        height={height}
        alt={alt}
      />
      <CenterLogo
        className="app-logo--dark"
        src={srcDark}
        width={width}
        height={height}
        alt=""
      />
    </>
  );
};
